var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',{staticClass:"meta-play-button",attrs:{"block":"","color":"primary","elevation":"0","x-large":"","disabled":_vm.disabled},on:{"click":function($event){return _vm.togglePlay()}}},[_c('BaseSpriteIcon',{attrs:{"custom-class":_vm.customClass,"icon-name":_vm.iconName}}),_vm._v("\n  "+_vm._s(_vm.label)+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }